"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapper_1 = require("@lcdev/mapper");
const util_1 = require("./util");
class EntityReference {
    constructor(type, id) {
        this.type = type;
        this.isEntityReference = true;
        this.id = util_1.toNum(id);
    }
    get [Symbol.toStringTag]() {
        return this.type.name;
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        // tslint:disable-line
        return `EntityReference<${this.type.name}> { ${this.id} }`;
    }
    toJSON() {
        return { id: this.id };
    }
}
exports.EntityReference = EntityReference;
class EntityMap {
    constructor(stores) {
        this.stores = [];
        if (stores) {
            this.stores.push(...stores);
        }
    }
    add(store) {
        this.stores.push(store);
    }
    addAll(stores) {
        this.stores.push(...stores);
    }
    lookup(type) {
        return this.stores.find(({ classType }) => type === classType);
    }
    resolve(obj, strict = true, properties) {
        const useProperty = (ctx) => {
            return properties.some((p) => {
                if (p === ctx)
                    return true;
                if (p.endsWith('[*]')) {
                    const ctxMatches = /(.*)\[\d+\]$/.exec(ctx);
                    if (ctxMatches) {
                        const [_, ctxPrefix] = ctxMatches;
                        if (p.startsWith(ctxPrefix)) {
                            return true;
                        }
                    }
                }
                return false;
            });
        };
        const resolved = mapper_1.mapper(obj, {
            custom: [
                [
                    (val, dataType, _, ctx) => {
                        if (properties && ctx && useProperty(ctx)) {
                            if (!(dataType === mapper_1.DataType.Object && val.isEntityReference)) {
                                throw new Error(`Property lookup ${ctx} did not find an EntityReference`);
                            }
                            return true;
                        }
                        return dataType === mapper_1.DataType.Object && val.isEntityReference;
                    },
                    (ref, _, __, ctx) => {
                        if (properties && ctx && !useProperty(ctx)) {
                            return ref;
                        }
                        const lookup = this.lookup(ref.type);
                        if (!lookup) {
                            throw new Error(`No EntityLookup for class ${ref.type.name}`);
                        }
                        const found = lookup.get(ref.id);
                        if (found === undefined && strict === true) {
                            throw new Error(`No entity (${ref.type.name}) found with id ${ref.id}`);
                        }
                        return found;
                    },
                ],
            ],
        });
        return resolved;
    }
}
exports.EntityMap = EntityMap;
exports.default = EntityMap;
//# sourceMappingURL=entity-map.js.map